import { storeToRefs } from 'pinia';
import type { SportType } from '@/interface/enum';
import { MarketType } from '@/interface/enum';
import { useToggleStore } from '@/store/toggleStore';

export function useTicketLiveScore() {
    const { scoringTypeASportType } = storeToRefs(useToggleStore());

    function isShowLiveScore(sportType: SportType, isLive: boolean, marketType: MarketType): boolean {
        if (marketType === MarketType.OutRight) return false;
        if (marketType === MarketType.SH_CorrectScore) return false;
        return scoringTypeASportType.value.includes(sportType) && isLive;
    }

    return {
        isShowLiveScore,
    };
}
